import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { navtoggle } from "../../../store/actions/AuthActions";
import { ThemeContext } from "../../../context/ThemeContext";

/**
 * Bouton hamburger (ouvrir / réduire la barre latérale), affiché dans le
 * header. L'état redux `sideMenu` pilote la classe "menu-toggle" de
 * #main-wrapper (voir jsx/index.js).
 */
const MenuToggleButton = () => {
  const { openMenuToggle } = useContext(ThemeContext);
  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(navtoggle());
    openMenuToggle();
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      aria-label="Menu"
      className="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-me-3 tw-rounded-md tw-bg-transparent tw-border-0 tw-text-gray-700 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-white/10"
    >
      <i className="ti ti-menu-2 fs-22"></i>
    </button>
  );
};

export default MenuToggleButton;
